import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)

  return (
    data?.map((item: any, index: any) => {
      return {
        approvalStatus: item?.approvalStatus,
        approvalType: item?.approvalType,
        className: item?.approvalType,
        id: item?.id,
        key: item?.key,
        type: item?.type,
        username: item?.username,
        data: {
          type: 'netbank',
          bankName: item?.object?.bankName,
          entityCode: item?.object?.entityCode,
          entityId: item?.object?.entityId,
          id: item?.object?.id?.toString() ?? '',
          rpslCode: item?.object?.rpslCode,
          status: item?.object?.status,
        },
      }
    }) ?? []
  )
}

const getNetbankingPendingApprovals = (elevated: boolean, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.nBMappingApprovals),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: {
      elevated,
    },
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getNetbankingPendingApprovals }
